import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type LessonScheduleInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function LessonScheduleInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: LessonScheduleInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M20.166 5.896H8.5a4.667 4.667 0 00-4.667 4.666V20.77A4.667 4.667 0 008.5 25.438h11.666a4.667 4.667 0 004.667-4.667V10.562a4.667 4.667 0 00-4.667-4.666zM3.833 12.896h21M20.166 3.563v4.666M8.5 3.563v4.666"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default LessonScheduleInactiveIcon;
